module.exports = __webpack_public_path__ + "img/1557614071120994305.8f6adc13.png";